import React, { useEffect, useState } from 'react';
import { fetchDocs } from '../services/api';
import { useNavigate } from 'react-router-dom';

export default function DocsViewer() {
    const [docs, setDocs] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        loadDocs();
    }, []);

    const loadDocs = async () => {
        try {
            const res = await fetchDocs();
            setDocs(res.data);
            setError(null);
        } catch (err) {
            console.error('Failed to load docs:', err);
            setError('Failed to load documentation');
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="animate-pulse p-4">Loading documentation...</div>;
    if (error) return <div className="text-red-500 p-4">{error}</div>;
    if (!docs) return <div className="p-4">No documentation data available</div>;

    return (
        <div className="px-4 py-5 sm:p-6">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Documentation Status
                </h3>
                <button
                    onClick={() => navigate('/docs-details')}
                    className="text-sm text-blue-600 hover:text-blue-800"
                >
                    View All →
                </button>
            </div>
            
            <div>
                <div className="grid grid-cols-2 gap-4 mb-4">
                    <div className="bg-green-50 rounded-lg p-4">
                        <p className="text-xl font-bold text-green-900">
                            {docs.documentation_percentage || 0}%
                        </p>
                        <p className="text-xs text-green-700">Documented</p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                        <p className="text-xl font-bold text-gray-900">
                            {docs.documented_tables || 0}/{docs.total_tables || 0}
                        </p>
                        <p className="text-xs text-gray-700">Tables</p>
                    </div>
                </div>
                
                {docs.recent_documentations && docs.recent_documentations.length > 0 && (
                    <>
                        <h4 className="text-sm font-medium text-gray-700 mb-2">
                            Recently Documented:
                        </h4>
                        <div className="space-y-2 max-h-48 overflow-y-auto">
                            {docs.recent_documentations.map((item, idx) => (
                                <div key={idx} className="bg-gray-50 rounded p-2">
                                    <p className="text-xs font-medium">{item.table}</p>
                                    <p className="text-xs text-gray-600 mt-1 truncate">
                                        {item.description}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}